import React from "react";
import { useFormContext } from "react-hook-form";
import {
    ContentSection,
    FailureSeverity,
    FormDropdown,
    ValidationFailure,
    mapToDropdownOption
} from "sprint-common-web";
import { FormFailureMessages } from "sprint-common-web/src/components/forms/FormFailureMessages";

import { useCreateFileRecordFormOptions } from "../hooks/useCreateFileRecordFormOptions";

export interface CreateSubtitleFileRecordLanguagesFormProps {
    validationFailures?: ValidationFailure[];
}

export const CreateSubtitleFileRecordLanguagesForm: React.FC<CreateSubtitleFileRecordLanguagesFormProps> = ({
    validationFailures
}: CreateSubtitleFileRecordLanguagesFormProps) => {
    const { dynamicSubtitles, areOptionsLoading } = useCreateFileRecordFormOptions();

    const { errors, control } = useFormContext();

    return (
        <ContentSection
            header="Languages"
            isLoading={areOptionsLoading}
            style={{ minHeight: "39vh", marginBottom: "2vh" }}
        >
            <FormDropdown
                options={dynamicSubtitles.map((subtitle) => mapToDropdownOption(subtitle))}
                label="Subtitle"
                name={"subtitleSubtitles"}
                control={control}
                errors={errors}
            />
            <FormFailureMessages failures={validationFailures ?? []} severity={FailureSeverity.Error} />
        </ContentSection>
    );
};
